const FETCH_TAG_RELATED_CONTENT = "FETCH_TAG_RELATED_CONTENT";
const FETCH_TAG_RELATED_CONTENT_SUCCESS = "FETCH_TAG_RELATED_CONTENT_SUCCESS";
const FETCH_TAG_RELATED_CONTENT_FAIL = "FETCH_TAG_RELATED_CONTENT_FAIL";

export default {
  FETCH_TAG_RELATED_CONTENT,
  FETCH_TAG_RELATED_CONTENT_SUCCESS,
  FETCH_TAG_RELATED_CONTENT_FAIL,
};
